import toaster, { ToastOptions } from 'react-hot-toast';

import { AlertError, AlertInfo, AlertSuccess, AlertWarning } from '@/components/common';
import { ALERT_DURATION, ALERT_FADE_DURATION } from '@/constants';

// Queue to manage error toasts, ensuring they display one at a time
const errorQueue: { message: string; options?: ToastOptions }[] = [];
let isErrorShowing = false;

export const Alert = {
  info: (message: string, options?: ToastOptions) => {
    toaster.custom((t) => <AlertInfo message={message} t={t} />, options);
  },
  error: (message: string, options?: ToastOptions) => {
    errorQueue.push({ message, options });
    if (!isErrorShowing) {
      Alert.next();
    }
  },
  success: (message: string, subtitle?: string, options?: ToastOptions) => {
    toaster.custom((t) => <AlertSuccess message={message} subtitle={subtitle} t={t} />, options);
  },
  warning: (message: string, options?: ToastOptions) => {
    toaster.custom((t) => <AlertWarning message={message} t={t} />, options);
  },
  next: () => {
    if (errorQueue.length === 0) {
      isErrorShowing = false;
      return;
    }

    isErrorShowing = true;
    const next = errorQueue.shift();
    if (!next) return;
    const { message, options } = next;
    const duration = options?.duration ?? ALERT_DURATION;

    toaster.custom((t) => <AlertError message={message} t={t} />, {
      ...options,
      duration: duration,
    });

    setTimeout(() => {
      Alert.next();
    }, duration + ALERT_FADE_DURATION);
  },
};
